/* global angular */

angular
.module('gc.pub', [])

.service('PubService', ['$http', 'BASE_URL', function($http, BASE_URL) {
  'use strict';
 
  this.sendAudience = (threadId) => {
    return $http.get(BASE_URL + `/api/pub/has_read_comments/thread/${threadId}`);
  };

}]);
